import { render, staticRenderFns } from "./search-saved-messages.vue?vue&type=template&id=225810d3&scoped=true&"
import script from "./search-saved-messages.vue?vue&type=script&lang=js&"
export * from "./search-saved-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225810d3",
  null
  
)

export default component.exports